import { shouldUseMocks } from './mockApi'
import * as mock from './mockApi/recordsApi'
import { patientGet, patientPost, patientDelete } from './patientApi'

const BASE = '/api/secure/me/records'
const CTX = { requirePatientContext: true }

export async function listPrescriptions(profile, page = 1, pageSize = 20) {
  if (shouldUseMocks()) return mock.listPrescriptions(profile)
  const res = await patientGet(`${BASE}/prescriptions`, { ...CTX, params: { page, pageSize } })
  return res?.data || { items: [] }
}

export async function listNotes(profile, page = 1, pageSize = 20) {
  if (shouldUseMocks()) return mock.listNotes(profile)
  const res = await patientGet(`${BASE}/notes`, { ...CTX, params: { page, pageSize } })
  return res?.data || { items: [] }
}

export async function listDocuments(profile, page = 1, pageSize = 20) {
  if (shouldUseMocks()) return mock.listDocuments(profile)
  const res = await patientGet(`${BASE}/documents`, { ...CTX, params: { page, pageSize } })
  return res?.data || { items: [] }
}

export async function listSharedDocuments(profile, page = 1, pageSize = 20) {
  if (shouldUseMocks()) return mock.listSharedDocuments(profile)
  const res = await patientGet(`${BASE}/shared`, { ...CTX, params: { page, pageSize } })
  return res?.data || { items: [] }
}

/**
 * Authenticated fetch of a practitioner-shared file as an object URL. The delivery link the
 * patient received over WhatsApp/email expires; this one works for as long as the item stays
 * shared. Caller is responsible for URL.revokeObjectURL().
 */
export async function openSharedDocument(profile, id) {
  if (shouldUseMocks()) return mock.openSharedDocument(profile, id)
  const res = await patientGet(`${BASE}/shared/${encodeURIComponent(id)}/file`, {
    ...CTX,
    profileId: profile?.id,
    responseType: 'blob',
  })
  return URL.createObjectURL(res.data)
}

export async function uploadDocument(profile, body) {
  if (shouldUseMocks()) return mock.uploadDocument(profile, body)
  const res = await patientPost(`${BASE}/documents/upload`, body, CTX)
  return res?.data
}

export async function shareDocument(profile, id, body) {
  if (shouldUseMocks()) return mock.shareDocument(profile, id, body)
  const res = await patientPost(`${BASE}/documents/${encodeURIComponent(id)}/share`, body, CTX)
  return res?.data
}

export async function deleteDocument(profile, id) {
  if (shouldUseMocks()) return mock.deleteDocument(profile, id)
  await patientDelete(`${BASE}/documents/${encodeURIComponent(id)}`, CTX)
  return null
}

export async function listReceipts(profile, page = 1, pageSize = 20) {
  if (shouldUseMocks()) return mock.listReceipts(profile)
  const res = await patientGet(`${BASE}/receipts`, { ...CTX, params: { page, pageSize } })
  return res?.data || { items: [] }
}
